import { req } from './axiosFun';
/**
 * 运营管理
 **/
// 查询banner列表
export const activityRanking = (params) => { return req("post", "/yishantong-ui/banner/qryBannerList", params) };

// 修改banner状态
export const upStatus = (params) => { return req("post", "/yishantong-ui/banner/upStatus", params) };

// 修改banner
export const upBanner = (params) => { return req("post", "/yishantong-ui/banner/upBanner", params) };

//新增banner
export const addBanner = (params) => { return req("post", "/yishantong-ui/banner/addBanner", params) };

//删除banner配置
export const delBanner = (params) => { return req("post", "/yishantong-ui/banner/delBanner", params) };



// WEBPACK FOOTER //
// ./src/api/rankingApi.js